

    var echarts = require('../echarts');

    require('./boxplot/BoxplotSeries');
    require('./boxplot/BoxplotView');

    echarts.registerVisual(require('./boxplot/boxplotVisual'));
    echarts.registerLayout(require('./boxplot/boxplotLayout'));




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/boxplot.js
// module id = 797
// module chunks = 158